/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentListItemSendPhase = typeof EnrollmentListItemSendPhase[keyof typeof EnrollmentListItemSendPhase];


export const EnrollmentListItemSendPhase = {
  scheduling: 'scheduling',
  scheduled: 'scheduled',
  recalculating: 'recalculating',
  executing: 'executing',
  task_pending: 'task_pending',
  paused: 'paused',
  completed: 'completed',
  cancelled: 'cancelled',
  bounced: 'bounced',
  error: 'error',
} as const;
